export default __webpack_public_path__ + "static/media/iguana.f8af5c3a.webp";